import { Button, CardContent, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const CaseStudiesComponent = () => {
    const textRef = useRef();
    const history = useHistory();
      const handleScrollToTop = (event) => {
        // event.preventDefault(); // Prevent default anchor behavior
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth', // CSS property for smooth scrolling
        });
    };
    const caseStudiesList = [
        // {
        //     name: 'Case Study 1',
        //     title: 'Managing 200+ Subjects in 38+ languages',
        //     description: 'How one exam board went from manual chaos to measurable calm in a month. When a client first called us, their peak month looked like a storm front on radar: 200+ subjects, 38+ languages, printers on standby, and digital teams barely keeping up with changes.',
        //     imageUrl: '../assets/images/carousel-11.jpg',
        //     redirectUrl: '/casestudy1',
        //     background: 'radial-gradient(circle at 90% 50%, rgb(255 99 99 / 73%) 0%, rgba(0, 0, 0, 0) 50%), linear-gradient(76deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .15) 50%, rgba(0, 0, 0, 0) 100%), linear-gradient(to right, rgb(231 63 63 / 49%) 0%, rgb(222 116 116 / 95%) 60%, rgba(253, 128, 133, 0.9) 100%)'
        // },
        {
            name: 'Case Study 2',
            title: 'Collaboration Without Borders: 400 people, 600 papers, 0 drift',
            description: 'How a single workspace made distance irrelevant. The exam season doesn\'t care about geography or timezones. Authors in different cities, moderators and support specialists working nights.',
            imageUrl: '../assets/images/carousel-11.jpg',
            redirectUrl: '/casestudy2',
            background: 'white',
            color: 'black',
            size: '5'

        },
        {
            name: 'Case Study 3',
            title: 'Many Registration Campaigns, One Platform',
            description: 'How a single institute ran 25+ end-to-end recruitment sessions for 3,000+ candidates in parallel. The brief looked simple on paper and messy in real life: a renowned academic and research institute needed to run faculty recruitment at scale—multiple postings',
            imageUrl: '../assets/images/carousel-11.jpg',
            redirectUrl: '/casestudy3',
            color: 'white',
            // background: 'radial-gradient(circle at 90% 50%, rgb(0 0 0 / 30%) 0%, rgba(0, 0, 0, 0) 50%), linear-gradient(76deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.32) 50%, rgba(0, 0, 0, 0) 100%), linear-gradient(to right, rgb(69 69 69) 0%, rgba(169, 169, 169, 0.99) 60%, rgba(211, 211, 211, 0.95) 100%)'
            background: 'linear-gradient(112deg,rgba(29, 66, 102, 1) 0%, rgba(0, 175, 239, 1) 75%, rgba(111, 204, 239, 1) 100%)',

            size: '4'
        }
    ];

    return (
        <>
            <Container className="d-flex align-content-center card-container-case-study">
                <Row className="cards-container-margin" style={{ padding: '15px 0 45px 0' }}>
                    {caseStudiesList.map((caseStudy, index) => (
                        <Col xs={12} md={caseStudy?.size} style={{ marginBottom: '20px', height: '16rem' }}>
                            <div key={index} style={{
                                backgroundColor: 'rgb(255, 255, 255)',
                                backgroundSize: 'cover',
                                color: 'rgb(38, 38, 38)',
                                transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                                overflow: 'hidden',
                                position: 'relative',
                                borderRadius: '17px',
                                boxShadow: 'inherit',
                                width: '100%',
                                height: '100%',
                                background: caseStudy?.background
                            }}>
                                <div className="case-study-content" style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ padding: '1.5rem' }}>
                                        <div className="case-study-title" onClick={() => history.push(caseStudy.redirectUrl, '_blank')}>
                                            <h6 style={{ fontSize: '1.3rem', fontWeight: 'bold', margin: 0, lineHeight: '1.2', color: caseStudy?.color }}>
                                                {caseStudy.title}
                                            </h6>
                                        </div>
                                        <div className="case-study-description" onClick={() => history.push(caseStudy.redirectUrl, '_blank')} style={{ marginTop: '1rem' }}>
                                            <p
                                                variant="body2"
                                                color="textSecondary"
                                                className={`fadedText truncate`}
                                                style={{ fontWeight: 400, margin: 0, fontSize: '1rem', lineHeight: '1.2', color: caseStudy?.color }}
                                            >

                                                {caseStudy?.description}
                                            </p>
                                        </div>
                                        <div  style={{ width: '100%', display: 'flex', alignItems: 'center', position: 'absolute', bottom: '1rem' }}>
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                style={{ marginTop: '1rem', textTransform: 'Capitalize', borderRadius: '18px', border: '1px solid', color: caseStudy?.color }} // Full width button
                                                onClick={() => {
                                                    history.push(caseStudy?.redirectUrl);
                                                    handleScrollToTop();
                                                }}
                                            >
                                                Read Now
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </>
    )
}

export default CaseStudiesComponent;